import { render } from "./aboutDetail.vue?vue&type=template&id=5dd7550c&scoped=true&ts=true"
import script from "./aboutDetail.vue?vue&type=script&lang=ts"
export * from "./aboutDetail.vue?vue&type=script&lang=ts"

import "./aboutDetail.vue?vue&type=style&index=0&id=5dd7550c&scoped=true&lang=less"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd7550c"]])

export default __exports__